export default __webpack_public_path__ + "static/media/03.709b976e.jpg";